import { OnChunkReceived, sendAuthRequestWithErrorHandling } from '../api';
import {
  PreviewLogProps,
  SolveApiRequest,
  SolveApiResponse,
} from 'src/slices/workflow-preview/types';

export const initializeConversationApi = (
  action: SolveApiRequest,
  onChunkReceived: OnChunkReceived,
): Promise<SolveApiResponse | undefined> => {
  return sendAuthRequestWithErrorHandling(
    `${SOLVE_API_URL}solve/api/v1/conversation`,
    action,
    'POST',
    async () => action.solve_api_token,
    { isStream: action.stream, onChunkReceived },
  );
};

export const updateConversationApi = (
  action: SolveApiRequest,
  onChunkReceived: OnChunkReceived,
): Promise<SolveApiResponse | undefined> => {
  return sendAuthRequestWithErrorHandling(
    `${SOLVE_API_URL}solve/api/v1/conversation/${action.conversation_id}`,
    action,
    'PUT',
    async () => action.solve_api_token,
    { isStream: action.stream, onChunkReceived },
  );
};

export const getPreviewLogsApi = (params: {
  conversationId: string;
  token: string;
}): Promise<PreviewLogProps[]> => {
  return sendAuthRequestWithErrorHandling(
    `${SOLVE_API_URL}solve/api/v1/conversation/${params.conversationId}/preview-logs`,
    null,
    'GET',
    async () => params.token,
  );
};
